import set from 'lodash.set';
import get from 'lodash.get';
import moment from 'moment';

const sumTotals = (totals, path, key, obj) => {
  let runningTotal = get(totals, [...path, key, 'totalCount'], 0);
  let currentTotal = obj[key].totalCount;
  let newTotal = runningTotal + currentTotal;
  return set(totals, [...path, key, 'totalCount'], newTotal);
};

const setChartData = (totals, path, key, obj) => {
  let currentTotal = obj[key].totalCount;
  let chartData = get(totals, [...path, key, 'chartData']);
  if (!chartData) {
    set(totals, [...path, key, 'chartData'], []);
    chartData = get(totals, [...path, key, 'chartData']);
  }
  chartData.push(currentTotal);
};

export default class CampaignReport {
  constructor(campaignData, queryData) {
    this.tenantId = campaignData[0].tenantId;
    this.businessContextId = campaignData[0].businessContextId;
    this.type = campaignData[0].type;
    this.campaignId = campaignData[0].campaignId;
    this.labels = [];
    this.fromDate = queryData.fromDate;
    this.toDate = queryData.toDate;
    this.dataHierarchy = queryData.dataHierarchy;
    this.data = campaignData;
    this.dateType = queryData.dateType;
    this.totalMetrics = this.processData(campaignData);
  }

  get lastDayTotalMetrics() {
    return this?.data[this.data.length - 1]?.totalMetrics;
  }

  processData(data) {
    let summarizedData = this.summarizeData(data);
    let calculatedRatesData = this.calculateMetricRates(summarizedData);
    return calculatedRatesData;
  }

  summarizeData(data) {
    let totals = {};
    const _traverseMetrics = (obj, path) => {
      Object.keys(obj).forEach(key => {
        if (Object.prototype.hasOwnProperty.call(obj[key], 'totalCount')) {
          sumTotals(totals, path, key, obj);
          setChartData(totals, path, key, obj);
        } else {
          _traverseMetrics(obj[key], [...path, key]);
        }
      });
    };

    data.forEach(item => {
      let label = this.createLabel(item.dateOfMetric);
      this.labels.push(label);
      _traverseMetrics(item.totalMetrics, []);
    });

    return totals;
  }

  createLabel(date) {
    if (this.dateType === 'DAY') {
      return moment(date).format('MM/DD');
    }

    if (this.dateType === 'MONTH') {
      return moment(date).format('YYYY/MM');
    }
  }

  calculateMetricRates(data) {
    let total = data?.totalRequested?.totalCount || 0;

    const _traverseAndCalculateRates = (obj, path) => {
      Object.keys(obj).forEach(key => {
        if (Object.prototype.hasOwnProperty.call(obj[key], 'totalCount')) {
          obj[key].totalPercentage = total > 0
            ? Math.round((obj[key].totalCount / total) * 100)
            : 0;
        } else {
          _traverseAndCalculateRates(obj[key]);
        }
      });
    };

    _traverseAndCalculateRates(data);
    return data;
  }
}
